import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
} from "@react-pdf/renderer";

export const ReportPDF = ({
    data,
    restaurantName,
    date,
    companyName = "The Plattr",
  }) => {

    // console.log("Inside the report", data)
    return (
      <Document>
        <Page style={styles.page}>
  
          {/* COMPANY HEADER */}
          <Text style={styles.company}>
            {companyName}
          </Text>
  
          {/* TITLE */}
          <Text style={styles.title}>
            Restaurant Performance Report
          </Text>
  
          <Text style={styles.text}>
            Restaurant: {restaurantName}
          </Text>
  
          <Text style={styles.text}>
            Report Date: {date}
          </Text>
  
          {/* SECTION 1 */}
          <Text style={styles.sectionTitle}>
            1. Report Summary
          </Text>
  
          <Text style={styles.text}>
            This report provides a comparative analysis of restaurant performance across Zomato and Swiggy platforms including orders, revenue, and marketing efficiency.
          </Text>
  
          {/* SECTION 2 */}
          <Text style={styles.sectionTitle}>
            2. Platform Comparison
          </Text>
  
          {/* TABLE HEADER */}
          <View style={styles.headerRow}>
            <Text style={styles.cell}>Metric</Text>
            <Text style={styles.cell}>Zomato</Text>
            <Text style={styles.cell}>Swiggy</Text>
            <Text style={styles.cell}>Insight</Text>
          </View>
  
          {/* TABLE ROWS */}
          {data.map((item, i) => (
            <View style={styles.row} key={i}>
              <Text style={styles.cell}>{item.metric}</Text>
              <Text style={styles.cell}>{item.zomato}</Text>
              <Text style={styles.cell}>{item.swiggy}</Text>
              <Text style={styles.cell}>{item.insight}</Text>
            </View>
          ))}
  
        
          {/* FOOTER */}
          <View style={styles.footer}>
            <Text>
              Generated by: {companyName}
            </Text>
  
            <Text>
              Time: {new Date().toLocaleString()}
            </Text>
  
            <Text style={{ marginTop: 5, fontWeight: 700 }}>
              CONFIDENTIAL — Internal Business Use Only
            </Text>
          </View>
  
        </Page>
      </Document>
    );
  };



  const styles = StyleSheet.create({
    page: {
      padding: 35,
      fontSize: 10,
      fontFamily: "Helvetica",
    },
  
    company: {
      fontSize: 14,
      fontWeight: 700,
      marginBottom: 5,
      color: "#1f2937",
    },
  
    title: {
      fontSize: 18,
      fontWeight: 700,
      marginBottom: 10,
    },
  
    sectionTitle: {
      fontSize: 12,
      marginTop: 15,
      marginBottom: 6,
      fontWeight: 700,
      backgroundColor: "#f3f4f6",
      padding: 4,
    },
  
    text: {
      fontSize: 10,
      marginBottom: 4,
      color: "#374151",
    },
  
    table: {
      marginTop: 10,
      border: "1px solid #e5e7eb",
    },
  
    row: {
      flexDirection: "row",
      borderBottom: "1px solid #e5e7eb",
      paddingVertical: 6,
    },
  
    headerRow: {
      flexDirection: "row",
      backgroundColor: "#111827",
      color: "#fff",
      paddingVertical: 6,
    },
  
    cell: {
      width: "25%",
      paddingLeft: 5,
    },
  
    footer: {
      marginTop: 25,
      borderTop: "1px solid #e5e7eb",
      paddingTop: 10,
      fontSize: 9,
      color: "gray",
    },
  });